import style from './index.module.scss';

const second_option = {
  label: 'Qual a sua experiência com concursos?',
  options: [
    { label: 'Estou começando agora', value: 'beginner' },
    { label: 'Já estudo há um tempo', value: 'experient' },
    { label: 'Estudo há muito tempo', value: 'highly_experient' },
    { label: 'Sou servidor público', value: 'professional' }
  ]
};

const contests = [
  {
    key: 'concursos',
    title: 'Concurso Público',
    className: style.public,
    icon: 'q-icon-calendar-check',
    form: {
      first_option: {
        label: 'Quais são as suas carreiras de interesse?',
        options: [
          { 'label': 'Fiscal','value': '3' },
          { 'label': 'Tribunal','value': '18' },
          { 'label': 'Policial','value': '6' },
          { 'label': 'Bancária','value': '1' },
          { 'label': 'Legislativa','value': '5' },
          { 'label': 'Controle','value': '2' },
          { 'label': 'Administrativa','value': '28' },
          { 'label': 'Educação','value': '8' },
          { 'label': 'Saúde','value': '17' },
          { 'label': 'Jurídica','value': '4' },
          { 'label': 'Outras','value': '7' }
        ]
      },
      second_option
    }
  },
  {
    key: 'militares',
    title: 'Forças armadas',
    className: style.military,
    icon: 'q-icon-medal',
    form: {
      first_option: {
        label: 'Quais são os seus interesses?',
        options: [
          { 'label': 'Marinha','value': '13' },
          { 'label': 'Exercito','value': '10' },
          { 'label': 'Aeronáutica','value': '9' }
        ]
      },
      second_option
    }
  },
  {
    key: 'enem_vestibulares',
    title: 'Enem e Vestibular',
    className: style.vestibular,
    icon: 'q-icon-file-contract',
    form: {
      first_option: {
        label: 'Qual o seu maior foco?',
        options: [
          { 'label': 'Enem','value': 'enem' },
          { 'label': 'Vestibular','value': 'vestibular' }
        ]
      },
      second_option
    }
  },
  {
    key: 'oab',
    title: 'OAB',
    className: style.oab,
    icon: ' q-icon-balance-scale',
    form: {
      first_option: null,
      second_option
    }
  }
];

export default contests;
